export const apiKey = "AIzaSyBCPXRRNzLshFM5YobuNY_DNR0B5Ym_o6s";
export const emailSecret = "iOY41QkKszqd6deLoeVfYwS73ZSv5CMKB6CcQ7cF";
